// Tokens de design especificos da aba "Claude Code" (MCP). O chrome comum
// (header, botao de acao, empty state, dialog) vem de ../ApisComponent.design —
// aqui so o que e genuinamente novo: mascara de token, banner de "revelar uma
// vez" e o bloco de comando copiavel.
export const MCP_TOKENS_DESIGN = {
    tokenChip: 'bg-gray-100 px-2 py-1 rounded text-xs text-gray-600 font-mono flex-1 truncate',
    status: {
        ativo: 'text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border-green-200',
        ativoDot: 'w-1.5 h-1.5 rounded-full bg-green-500',
        revogado: 'text-xs font-medium flex items-center gap-1.5 bg-gray-50 text-gray-500 border-gray-200',
        revogadoDot: 'w-1.5 h-1.5 rounded-full bg-gray-400',
    },
    reveal: {
        warningBanner: 'flex items-start gap-3 p-4 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 text-sm',
        tokenBox: 'flex items-center gap-2 p-3 rounded-xl bg-gray-900 text-gray-100',
        tokenText: 'flex-1 font-mono text-xs break-all',
        commandLabel: 'block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2',
        commandBox: 'relative rounded-xl bg-gray-900 text-gray-100 p-3 pr-10',
        commandText: 'font-mono text-xs whitespace-pre-wrap break-all',
        copyButton: 'absolute top-2 right-2 p-1.5 hover:bg-white/10 rounded-md text-gray-300 transition-colors',
        urlMissingNote: 'text-xs text-amber-700 mt-2',
        connectorHint: 'text-xs text-gray-500 mt-2 leading-relaxed',
    },
};
